import { Component } from "react";
import { Modal } from "react-bootstrap";
import { popCancelBttn } from "../../assets";
import Button from "../Button";
import './GlobalSearchFeaturesPopUp.css'
import './PinToReadingListPopUp.css'
import DublicateCollectionPopUp from "./DublicateCollectionPopUp";
import ApiServices from "../../utils/apiServices";
import { snippetLongString } from "../../utils/utilityServices"
import AlertMessagePopUpModal from "./AlertMessagePopUpModal";
class RenameCollectionPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collectionName: '',
            collectionId: '',
            showPop: false,
            showDublicateModal: false,
            error: {},
            alertMessageModelColor: "",
            alertMessageContent: "",
            alertMessageShowModal: false,
        }
    }
    componentDidMount() {
        this.setState({
            showPop: this.props.showModal,
            collectionName: this.props.collectionName,
            collectionId: this.props.collectionId
        });
    }
    successAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#00c12c",
            alertMessageShowModal: true
        })
    }
    closeAlertMessage = () => {
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            showPop: false,
            alertMessageShowModal: false
        })
        this.props.handleClose(false)
    }
    handleSave = async () => {
        let service = new ApiServices();
        if (this.handleValidation()) {
            let res = await service.updateCollection(this.state.collectionName, this.state.collectionId);
            if (res) {
                this.successAlertMessage('Collection Name saved successfully')
            }
        }
    }
    handleInput = (e) => {
        e.target.value = snippetLongString(e.target.value);
        this.setState({
            collectionName: e.target.value
        })
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        let collection = this.props.apiResponse.filter(x => x.collection_id !== this.state.collectionId).map(data => data.collection_name.toLowerCase())
        if (this.state.collectionName.length <= 0) {
            formIsValid = false;
            errors["collectionName"] = 'Please enter value.';
        }
        if (collection.includes(this.state.collectionName.toLowerCase())) {
            formIsValid = false;
            // this.setState({ showDublicateModal: true });
            errors["collectionName"] = `Collection name must be unique. Please give a different name other than '${this.state.collectionName}'.`;
        }
        this.setState({ error: errors });
        return formIsValid;
    }
    render() {
        const { alertMessageModelColor, alertMessageContent, alertMessageShowModal } = this.state;
        if (this.props.customWidth <= 1000) {
            return (
                <>
                    <Modal
                        show={this.state.showPop}
                        size="lg md sm xs"
                        centered
                        aria-labelledby="contained-modal-title-vcenter"
                        dialogClassName="popup-transition"
                        className="z-index-rename"
                        backdropClassName="z-index-rename-backdrop"
                        scrollable={true}
                    >
                        <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
                            <div>
                                <Modal.Header className="gsfModalHeader" style={{ justifyContent: "left", padding: "0.5rem 0" }}>
                                    <div style={{ textAlign: "center", width: "100%", paddingTop: "1%" }}>
                                        <Modal.Title>
                                            <div className="actionItem-headerPart">
                                                Rename Collection
                                            </div>
                                        </Modal.Title>
                                    </div>
                                </Modal.Header>
                                <Modal.Body scrollable={true} style={{ minHeight: "25vh" }}>
                                    <table className="manage-personal-alerts-wrapper">
                                        <tr><th>Collection Name</th><th style={{ textAlign: "center" }}>Actions</th></tr>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "90%" }}><input type="text" value={this.state.collectionName} style={{ width: "100%" }} onChange={this.handleInput} /><br /><div className="errorInvalidName">{this.state.error["collectionName"]}</div></td>
                                                <td style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", width: "100%" }}><span title="Save" onClick={e => this.handleSave()} className="reading-list-action-text">Save</span></td>
                                            </tr>
                                            <span className="length-info">Name with a maximum of 100 characters.</span>
                                        </tbody>
                                    </table>
                                </Modal.Body>
                                <div className="reading-list-button-tablet-wrapper">
                                    <Button text="Cancel" customColor="#000000" action={() => {
                                        this.setState({ showPop: false });
                                        this.props.handleClose(false);
                                    }} />
                                </div>
                            </div>
                        </div>
                        {this.state.showDublicateModal &&
                            <>
                                <DublicateCollectionPopUp showModal={this.state.showDublicateModal} handleClose={(status) => { this.setState({ showDublicateModal: status }) }} color="#0074B0" collectionName={this.state.collectionName} />
                                <div className="savemodal-outer-wrapper"></div>
                            </>
                        }
                    </Modal>
                    {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                </>
            )
        }
        else {

            return (<>
                <Modal
                    show={this.state.showPop}
                    size="lg md sm xs"
                    centered
                    aria-labelledby="contained-modal-title-vcenter"
                    dialogClassName="popup-transition"
                    className="z-index-rename"
                    backdropClassName="z-index-rename-backdrop"
                    scrollable={true}
                >
                    <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
                        <div className="popup-cancel-btn-wrapper">
                            <img
                                src={popCancelBttn}
                                alt=""
                                onClick={e => {
                                    this.setState({ showPop: false });
                                    this.props.handleClose(false);
                                }}
                            />
                        </div>
                        <div>
                            <Modal.Header className="gsfModalHeader" style={{ justifyContent: "left" }}>
                                <div style={{ textAlign: "center", width: "30%", paddingTop: "1%" }}>
                                    <Modal.Title>
                                        <div className="actionItem-headerPart">
                                            Rename Collection
                                        </div>
                                    </Modal.Title>
                                </div>
                            </Modal.Header>
                            <Modal.Body scrollable={true} style={{ minHeight: "25vh" }}>
                                <table className="manage-personal-alerts-wrapper" /* className="reading-list-view-wrapper" */>
                                    <tr><th>Collection Name</th><th style={{ textAlign: "center" }}>Actions</th></tr>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: "90%" }}><input type="text" value={this.state.collectionName} style={{ width: "100%" }} onChange={this.handleInput} /><br /><div className="errorInvalidName">{this.state.error["collectionName"]}</div></td>
                                            <td style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", width: "100%" }}><span title="Save" onClick={e => this.handleSave()} className="reading-list-action-text">Save</span></td>
                                        </tr>
                                        <span className="length-info">Name with a maximum of 100 characters.</span>
                                    </tbody>
                                </table>
                            </Modal.Body>
                            <div className="reading-list-button-wrapper">
                                <Button text="Cancel" customColor="#000000" action={() => {
                                    this.setState({ showPop: false });
                                    this.props.handleClose(false);
                                }} />
                            </div>
                        </div>
                    </div>
                    {this.state.showDublicateModal &&
                        <>
                            <DublicateCollectionPopUp showModal={this.state.showDublicateModal} handleClose={(status) => { this.setState({ showDublicateModal: status }) }} color="#0074B0" collectionName={this.state.collectionName} />
                            <div className="savemodal-outer-wrapper"></div>
                        </>
                    }
                </Modal>
                {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
            </>
            )
        }
    }
}
export default RenameCollectionPopup;